import { ButtonGroup, Css, Switch, useTestIds } from "@homebound/beam";
import { OptionPriceMode } from "src/routes/projects/change-events/guided/workflows/components/OptionPrice";

export type OptionsFilterBarProps = {
  showExpired: boolean;
  onShowExpired: (showExpired: boolean) => void;
  priceMode: OptionPriceMode;
  onPriceMode: (priceMode: OptionPriceMode) => void;
};

/** The Select Options step's header filters: whether to show groups past their cutoff, and price vs. cost. */
export function OptionsFilterBar(props: OptionsFilterBarProps) {
  const { showExpired, onShowExpired, priceMode, onPriceMode } = props;
  const tid = useTestIds(props, "optionsFilterBar");
  return (
    <div css={Css.df.aic.jcsb.gap2.$} {...tid}>
      <Switch
        label="Show expired options"
        labelStyle="inline"
        selected={showExpired}
        onChange={onShowExpired}
        tooltip="Expired options are past their cutoff date and can no longer be added. Turn this on to show expired groups that aren't currently selected. Groups with existing selections are always visible."
        {...tid.showExpired}
      />
      <ButtonGroup
        buttons={[
          {
            text: "Price",
            active: priceMode === OptionPriceMode.Price,
            onClick: () => onPriceMode(OptionPriceMode.Price),
          },
          {
            text: "Cost",
            active: priceMode === OptionPriceMode.Cost,
            onClick: () => onPriceMode(OptionPriceMode.Cost),
            tooltip:
              "The option's full internal cost from the takeoff, before markup. Unlike price, it is not a delta from the included option, so included options still show a cost.",
          },
        ]}
        {...tid.priceMode}
      />
    </div>
  );
}
